export default {
  "Audit logs": "Journaux d'audit",
  "audit logs": "journaux d'audit",
  Created: "Créé",
  Updated: "Mis à jour",
  Deleted: "Supprimé",
  Viewed: "Consulté",
  Success: "Succès",
  success: "succès",
  Failure: "Échec",
  failure: "échec",
  Pending: "En attente",
  pending: "en attente",
  User: "Utilisateur",
  user: "utilisateur",
  Action: "Action",
  action: "action",
  Resource: "Ressource",
  resource: "ressource",
  Summary: "Résumé",
  summary: "résumé",
  Changes: "Modifications",
  changes: "modifications",
  Date: "Date",
  date: "date",
  System: "Système",
  system: "système",
  "fields changed": "champs modifiés",
  "Resource created": "Ressource créée",
  "Resource deleted": "Ressource supprimée",
  "Resource viewed": "Ressource consultée",
  "No details available": "Aucun détail disponible",
  Yes: "Oui",
  yes: "oui",
  No: "Non",
  no: "non",
  "Metadata updated": "Métadonnées mises à jour",
  clipboard: "presse-papiers",
};
